export enum RemindersStatusCodes {
  Captured = 'CAP',
  Complete = 'RED',
}
